<template>
  <div class="mx-auto" style="width:100%; max-width:950px">
    <v-card flat class="mt-2">
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" md="12">
              <FieldValue
                :Text="
                  $store.state.eventInfo.EventId == 2063
                    ? 'Team Name'
                    : 'Company Name'
                "
                :Value="$store.state.eventInfo.VendorName"
              ></FieldValue>
            </v-col>
            <v-col cols="12" md="12">
              <FieldValue
                :Text="
                  $store.state.eventInfo.EventId == 2063
                    ? 'As a team, what does breaking limits mean to you?'
                    : 'Company Address'
                "
                :Value="vData.company_address"
              ></FieldValue>
            </v-col>
            <v-col cols="12" md="6">
              <FieldValue
                Text="Email Id"
                :Value="$store.state.eventInfo.VendorEmail"
              ></FieldValue>
            </v-col>
            <v-col cols="12" md="6">
              <FieldValue
                :Text="
                  $store.state.eventInfo.EventId == 2063
                    ? 'Selected Festival'
                    : 'Company Phone'
                "
                :Value="vData.company_phone_no"
              ></FieldValue>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="12" md="6">
              <FieldValue
                Text="Contact Person"
                :Value="vData.vendor_name"
              ></FieldValue>
            </v-col>
            <v-col cols="12" md="6">
              <FieldValue
                Text="Contact Number"
                :Value="vData.vendor_contact_no"
              ></FieldValue>
            </v-col>

            <!-- <v-col cols="12" md="6">
              <FieldValue
                Text="ID Proof"
                :Value="vData.vendor_doc_type"
              ></FieldValue>
            </v-col>
            <v-col cols="12" md="6">
              <FieldValue
                Text="ID Proof Number"
                :Value="vData.vendor_doc_no"
              ></FieldValue>
            </v-col> -->
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card flat class="mt-2">
      <v-card-title style="font-size: 1.1rem">
        Term and Conditions
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <div v-html="tchtml"></div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FieldValue from "../components/application/FieldValue";
import axios from "axios";
export default {
  layout: "login",
  components: { FieldValue },
  data() {
    return {
      vData: {},
      tchtml: "",
    };
  },

  async mounted() {
    this.$store.commit("setPageTitle", "Company Profile");
    this.txtcompanyname = this.$store.state.eventInfo.VendorName;
    this.txtcompanypersonemail = this.$store.state.eventInfo.VendorEmail;
    await this.$axios
      .get("Vendor/" + this.$store.state.eventInfo.VendorId)
      .then((res) => {
        this.vData = res.data.result;
      });
    await axios
      .get(
        this.$apiPhotoPath +
          "/assets/" +
          this.$store.state.eventInfo.EventUrl +
          "/tnc/local.html"
      )
      .then((response) => {
        this.tchtml = response.data;
      })
      .catch();
  },
  methods: {},
};
</script>

<style>
.text-center {
  text-align: center;
}
.forcolor {
  color: black;
}
</style>